<button class="gonvarri-product-notification" (click)="openDialog()" type="button">
  <div class="gonvarri-product-notification__icon">
    <svg *ngIf="!notificationRegistered"
         xmlns="http://www.w3.org/2000/svg"
         width="32" height="32"
         fill="currentColor"
         viewBox="0 0 16 16"
         class="bi bi-envelope">
      <path
        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
    </svg>

    <svg *ngIf="notificationRegistered" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
         class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
      <path
        d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
      <path
        d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
    </svg>

  </div>

  <div class="gonvarri-product-notification__text">
    {{ notificationLabel | cxTranslate }}
  </div>
</button>
